import {
  FormikTagPicker,
  FormikTagPickerProps,
} from 'components/TagPicker/FormikTagPicker'
import { sortBy } from 'lodash-es'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import {
  AsyncDropdown,
  AsyncDropdownProps,
  FormikAsyncDropdownFactory,
} from '../AsyncDropdown'
import { useDepartmentDropdownQuery } from './DepartmentDropdown.generated'

export type DepartmentDropdownProps = Omit<
  AsyncDropdownProps,
  'onResolveOptions'
>

export const DepartmentDropdown: React.FC<DepartmentDropdownProps> = ({
  ...props
}) => {
  let resolve: any
  const resolveOptions: PromiseLike<IDropdownOption[]> = new Promise<
    IDropdownOption[]
  >((r, e) => {
    resolve = r
  })

  useDepartmentDropdownQuery({
    onCompleted: (data) => {
      const options: IDropdownOption[] = data.allMaintenanceAreas.map(
        (department) => ({
          key: department,
          text: department,
        })
      )
      resolve(sortBy(options, 'text'))
    },
  })

  return <AsyncDropdown onResolveOptions={resolveOptions} {...props} />
}

export const FormikDepartmentDropdown =
  FormikAsyncDropdownFactory(DepartmentDropdown)

export type DepartmentPickerProps = Omit<FormikTagPickerProps, 'tags'>

export const FormikDepartmentPicker: React.FC<DepartmentPickerProps> = ({
  field,
  form,
  ...props
}) => {
  const { loading, data } = useDepartmentDropdownQuery()
  const options =
    !loading && data
      ? data.allMaintenanceAreas.map((dep) => ({ key: dep, name: dep }))
      : []

  return <FormikTagPicker tags={options} {...{ field, form }} {...props} />
}
